import { Constant } from "../../constants/constant";

export function propsToInitialState(data) {
  const dataInit = { ...data };
  dataInit.ngayHoatDong = data?.ngayHoatDong || null;
  dataInit.thoiGianNgungHoatDong = data?.thoiGianNgungHoatDong || null;
  dataInit.phuongXa = data?.donViHanhChinh_Xa || null;
  dataInit.quanHuyen = data?.donViHanhChinh_Huyen || null;
  dataInit.tinhThanh = data?.donViHanhChinh_Tinh || Constant.TINHTHANH;

  dataInit.tinhTrangHoatDong = data?.tinhTrangHoatDong === false ? false : true;
  dataInit.fileImages = data?.fileImage?.file_path
    ? [
        {
          bucket_name: data.fileImage?.bucket_name || null,
          file_path: data.fileImage?.file_path || null,
          file_oid: data.fileImage?.file_oid || 0,
          file_name: data.fileImage?.file_name || null,
          file_ext: data.fileImage?.file_ext || null,
          file_size: data.fileImage?.file_size || 0
        }
      ]
    : null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.ngayHoatDong = value?.ngayHoatDong || 0;
  dataSave.thoiGianNgungHoatDong = value?.thoiGianNgungHoatDong || 0;
  dataSave.ngayHoatDong = value?.ngayHoatDong || 0;
  dataSave.maTinh = value?.tinhThanh?.maTinh || null;
  dataSave.maHuyen = value?.quanHuyen?.maHuyen || null;
  dataSave.maXa = value?.phuongXa?.maXa || null;
  dataSave.fileImage = value?.fileImages?.[0]?.file_path
    ? value?.fileImages?.[0]
    : null;
  dataSave.tinhTrangHoatDong = value?.tinhTrangHoatDong || false;
  return dataSave;
}
